import _regeneratorRuntime from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _defineProperty from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _toConsumableArray from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import _ from 'lodash';
import { isPromise } from '@jutro/platform';
import { log } from '@jutro/logger';
import { showAlert } from './alertHelper';
import { navigateTo } from './navigationHelper';
import { getErrorCategory } from './errorCategorizer';
export function invokeAction(name, props, context, onSuccess, onFailure) {
  var actionFunction = props.function;
  var actionArgs = props.args;

  if (!actionFunction || _.isString(actionFunction)) {
    log.error("Could not resolve action function: \"".concat(actionFunction || name, "\""));
    return undefined;
  }

  if (actionArgs) {
    actionArgs = _mapInstanceProperty(actionArgs).call(actionArgs, function (prop) {
      return context[prop];
    });
  }

  var result;
  var resultException;

  try {
    result = actionArgs ? actionFunction.apply(void 0, _toConsumableArray(actionArgs)) : actionFunction();
  } catch (ex) {
    result = false;
    resultException = ex;
  }

  return {
    name: name,
    result: result,
    resultException: resultException,
    progress: props.progress,
    success: props.success,
    failure: props.failure,
    onSuccess: onSuccess,
    onFailure: onFailure
  };
}
export function actionResultWithPaths(result, successPath, failurePath, progressMsg) {
  var actionObject = {
    name: 'unnamed',
    result: result
  };

  if (progressMsg !== undefined) {
    actionObject.progress = {
      message: progressMsg
    };
  }

  if (successPath !== undefined) {
    actionObject.success = {
      path: successPath
    };
  }

  if (failurePath !== undefined) {
    actionObject.failure = {
      path: failurePath
    };
  }

  return actionObject;
}
export function handleAction(actionObject, instance, translator) {
  var name, result, resultException, progress, success, failure, onSuccess, onFailure, _ref, message, _ref2, to, toMessage, _ref3, failTo, failToMessage, onAlert, onNavigate, data, computedFailTo, errorData, errorCategory, knockoutPath, errorProps;

  return _regeneratorRuntime.async(function handleAction$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!instance) {
            _context2.next = 4;
            break;
          }

          if (!(!instance.setState || !instance.props || !instance.props.history)) {
            _context2.next = 4;
            break;
          }

          log.error('"Instance" provided to AsyncLink.handleAction does not have "setState" or "history" props');
          return _context2.abrupt("return");

        case 4:
          name = actionObject.name, result = actionObject.result, resultException = actionObject.resultException, progress = actionObject.progress, success = actionObject.success, failure = actionObject.failure, onSuccess = actionObject.onSuccess, onFailure = actionObject.onFailure;
          _ref = progress || {}, message = _ref.message;
          _ref2 = success || {}, to = _ref2.path, toMessage = _ref2.message;
          _ref3 = failure || {}, failTo = _ref3.path, failToMessage = _ref3.message;
          onAlert = showAlert;
          onNavigate = navigateTo;

          if (isPromise(result)) {
            _context2.next = 20;
            break;
          }

          if (!(result !== false)) {
            _context2.next = 15;
            break;
          }

          if (onSuccess) {
            onSuccess(name, result);
          }

          if (to && onNavigate) {
            onNavigate(instance, to, result);
          } else if (toMessage && onAlert) {
            onAlert(translator(toMessage));
          }

          return _context2.abrupt("return");

        case 15:
          if (!(resultException !== undefined && resultException !== false)) {
            _context2.next = 19;
            break;
          }

          if (onFailure) {
            onFailure(name, resultException);
          }

          if (failTo && onNavigate) {
            onNavigate(instance, failTo, resultException);
          } else if (failToMessage && onAlert) {
            onAlert(translator(failToMessage));
          }

          return _context2.abrupt("return");

        case 19:
          return _context2.abrupt("return");

        case 20:
          _context2.prev = 20;

          if (instance) {
            instance.setState({
              loading: true,
              message: translator(message)
            });
          }

          _context2.next = 24;
          return _regeneratorRuntime.awrap(result);

        case 24:
          data = _context2.sent;

          if (instance) {
            instance.setState({
              loading: false,
              message: null
            });
          }

          if (data !== false) {
            if (onSuccess) {
              onSuccess(name, data);
            }

            if (to && onNavigate) {
              onNavigate(instance, to, data);
            } else if (toMessage && onAlert) {
              onAlert(translator(toMessage));
            }
          }

          _context2.next = 45;
          break;

        case 29:
          _context2.prev = 29;
          _context2.t0 = _context2["catch"](20);
          computedFailTo = failTo;

          if (_context2.t0 instanceof Error) {
            log.error("AsyncLink: ".concat(_context2.t0));
          }

          if (instance) {
            instance.setState({
              loading: false,
              message: null
            });
          }

          if (!(_context2.t0 === false)) {
            _context2.next = 36;
            break;
          }

          return _context2.abrupt("return");

        case 36:
          if (onFailure) {
            onFailure(name, _context2.t0);
          }

          if (!(_context2.t0 === false)) {
            _context2.next = 39;
            break;
          }

          return _context2.abrupt("return");

        case 39:
          errorData = _context2.t0;
          errorCategory = getErrorCategory(_context2.t0.errorCode || _context2.t0);
          knockoutPath = errorCategory.knockoutPath, errorProps = _objectWithoutProperties(errorCategory, ["knockoutPath"]);

          if (knockoutPath) {
            computedFailTo = knockoutPath;
          }

          if (!_.isEmpty(errorProps)) {
            errorData = _objectSpread({}, errorProps, {
              error: _context2.t0
            });
          }

          if (computedFailTo && onNavigate) {
            onNavigate(instance, computedFailTo, errorData);
          } else if (failToMessage && onAlert) {
            onAlert(translator(failToMessage));
          }

        case 45:
        case "end":
          return _context2.stop();
      }
    }
  }, null, null, [[20, 29]], Promise);
}
export function checkActionIntegrity(events, props, context) {
  if (!events || !props || !context) {
    return;
  }

  _forEachInstanceProperty(events).call(events, function (evt) {
    var actionProps = props[evt];

    if (actionProps) {
      if (_.isString(actionProps.function)) {
        log.error("Could not resolve action function: \"".concat(actionProps.function, "\". Check return from \"getActionFunctions()\""));
        return;
      }

      if (actionProps.function && actionProps.args) {
        var _context;

        var missing = _reduceInstanceProperty(_context = actionProps.args).call(_context, function (list, prop) {
          if (!Object.prototype.hasOwnProperty.call(context, prop)) {
            list.push(prop);
          }

          return list;
        }, []);

        if (missing.length !== 0) {
          log.error("Could not resolve action function arguments from action context: \"".concat(actionProps.name, "(").concat(missing, ")\". Check return from \"getActionContext()\""));
        }
      }
    }
  });
}